const enMessages = {
  '': '',
  ' ': ' ',

  // A

  'Afternoon Hour': 'ម៉ោងរសៀល',
  'Allocate Cost': 'ការបែកចែកចំណាយ',
  'Academic Year': 'ឆ្នាំសិក្សា',
  "Appraiser's Statement": 'សេចក្តីថ្លែងការណ៍របស់អ្នកវាយតម្លៃ',
  "Appraisee's Statement": 'សេចក្តីថ្លែងការណ៍របស់បុគ្គលិក',
  'Association Degree': 'បរិញ្ញាបត្ររង',
  Accepted: 'បានទទួល',
  'Annual Review': 'Annual Review',
  'Appraiser Comment': 'Appraiser Comment',
  "Appraisal's Statement": 'សេចក្តីថ្លែងការណ៍វាយតម្លៃ',
  'Appraisee Final Statement': 'សេចក្តីថ្លែងការណ៍វាយតម្លៃចុងក្រោយ',
  "APPRAISEES's COMMENTS": 'មតិយោបល់របស់បុគ្គលិក',
  "Appraisee's Comment": 'មតិយោបល់របស់បុគ្គលិក',
  "APPRAISEES' COMMENTS": 'មតិយោបល់របស់បុគ្គលិក',
  'Accomplished less than 50% of the expectation': 'សម្រេចបានតិចជាងការរំពឹងទុក 50%',
  'Accomplished 50% or more of the expectation': 'សម្រេចបានចាប់ពី 50% ប៉ុន្តែតូចជាងការរំពឹងទុក',
  'Accomplished just over expectations by less than 50%': 'សម្រេចបានលើសពីការរំពឹងទុកក្រោម 50%',
  'Tardiness or Attendance score': 'ពិន្ទុវត្តមាន ឬភាពយឺតយ៉ាវ',
  'Attendance Rating': 'Attendance Rating',
  'Tardiness or Attendance Result (Score)': 'លទ្ធផលពិន្ទុវត្តមាន ឬភាពយឺតយ៉ាវ',
  'Attendance Result (Score)': 'លទ្ធផលពិន្ទុចូលរួម',
  'Appraiser Final Statement': 'សេចក្តីថ្លែងការណ៍ចុងក្រោយរបស់អ្នកវាយតម្លៃ',
  'Appraisal Date & Statement': 'Appraisal Date & Statement',
  'Appraisal Date': 'ថ្ងៃខែឆ្នាំវាយតម្លៃ',
  'Address in Khmer': 'អាស័យដ្ឋានជាភាសាខ្មែរ',
  'Assign To Name': 'កំណត់ទៅឈ្មោះ',
  'Attendance Missing Hour': 'Attendance Missing Hour',
  'Assign To Name 2': 'កំណត់ទៅឈ្មោះ ២',
  Agreement: 'កិច្ចសន្យា',
  'Afternoon Break (Minute)': 'សម្រាកពេលរសៀល (នាទី)',
  'Absentee Employee No': 'និយោជិតអវត្តមាន',
  'Afternoon break no of minute': 'សម្រាកពេលរសៀល (នាទី)',
  'Afternoon Starting Time': 'ពេលរសៀលម៉ោងចាប់ផ្តើម',
  'Afternoon Ending Time': 'ពេលរសៀលម៉ោងបញ្ចប់',
  Attendance: 'ផ្នែកវត្តមាន',
  'Attendance History Record': 'ប្រវត្តិវត្តមានម៉ោងចេញចូលការងារ',
  'Attendance Missing Type': 'ប្រភេទនៃអវត្តមាន',
  'Attendance Missing Period': 'ពេលអវត្តមាន',
  'Actual In/Out Time': 'ពេលវេលាចូល/ចេញពិតប្រាកដ',
  Approver: 'អ្នកអនុម័ត',
  'Attachment Files': 'ឯកសារភ្ជាប់',
  'Approval Workflow Activities': 'គណៈកម្មការអនុម័ត',
  Address: 'អាស័យដ្ឋាន',
  'Appraisal Request Form': 'ពាក្យស្នើសុំវាយតម្លៃបុគ្គលិក',
  'Performance Appraisal Request': 'ពាក្យស្នើសុំវាយតម្លៃបុគ្គលិក',
  'Appraisal Rating': 'ការវាយតម្លៃ',
  'Appraisal Results': 'លទ្ធផលនៃការវាយតម្លៃ',
  'Appraisal Type': 'ប្រភេទនៃការវាយតម្លៃ',
  'Appraisal Summary Analysis': 'ការវិភាគសង្ខេបវាយតម្លៃ',
  'Appraisal Detail': 'ព័ត៌មានលម្អិតនៃការវាយតម្លៃ',
  Approved: 'បានអនុម័ត',
  Afternoon: 'ពេលរសៀល',
  Accept: 'អនុម័ត',
  'Attached a file on': 'បានភ្ជាប់ឯកសារ',
  'Appraisal Comment': 'មតិវាយតម្លៃ',
  'Assessment Training Training Plan Need': 'ការវាយតម្លៃផែនការបណ្តុះបណ្តាលលើតម្រូវការ',
  'Appraiser Rating Option': 'ការដាក់ពិន្ទុដោយអ្នកវាយតម្លៃ',
  "Appraiser's Comments": 'មតិរបស់អ្នកវាយតម្លៃ',
  'Appraiser Score': 'ការដាក់ពិន្ទុដោយ អ្នកវាយតម្លៃ',
  'Actual Achievement': 'សមិទ្ធិផលការងារជាក់ស្តែងដែលទទួលបាន',
  'Appraiser KPI Score': 'វាយតម្លៃពិន្ទុ KPI',
  'Appraiser Behavior and Skill Score': 'ពិន្ទុការវាយតម្លៃលើជំនាញ និងអាកប្បកិរិយា',
  'Annual Leave': 'ច្បាប់សម្រាកប្រចាំឆ្នាំ',
  Absence: 'អវត្តមាន',
  'Address (If any)': 'អាស័យដ្ឋាន(ប្រសិនបើមាន)',
  'Assessement Of Training': 'ការវាយតម្លៃគុណភាពថ្នាក់បណ្តុះបណ្តាល',
  Agree: 'យល់ស្រប',
  Attachment: 'ឯកសារ​ភ្ជាប់',
  'Achieving Results': 'សម្រេចបានលទ្ធផល',
  'Analytical Thinking': 'វិភាគការគិត',
  Add: 'បន្ថែម',
  'Assessment Of Training Survey': 'ការវាយតម្លៃគុណភាពថ្នាក់បណ្តុះបណ្តាល',
  A5: 'A5',
  A4: 'A4',
  'Assign To User': 'កំណត់ទៅអ្នកប្រើប្រាស់',
  'Assign To User 2': 'កំណត់ទៅអ្នកប្រើប្រាស់ ២',
  Announcements: 'សេចក្តីជូនដំណឹង',
  'Annual Leave Entitlement Balance': 'ការប្រើប្រាស់ច្បាប់សម្រាកប្រចាំឆ្នាំ',
  All: 'ទាំងអស់',
  'Approval Document': 'ឯកសារអនុម័ត',
  'Activity Status': 'ស្ថានភាពសកម្មភាព',
  'Activity Type': 'សកម្មភាពជាប្រភេទ',
  Aborted: 'បានបញ្ឈប់',
  'Activity Date': 'សកម្មភាពជាថ្ងៃខែ',
  'Activity Task Description': 'ការពិពណ៌នាអំពីភារកិច្ចសកម្មភាព',
  'Afternoon (In)': 'ពេលរសៀល (ចូល)',
  'Afternoon (Out)': 'ពេលរសៀល (ចេញ)',
  'Activity Tasks': 'សកម្មភាពជាភារកិច្ច',
  'Activity Time': 'សកម្មភាពជាម៉ោង',
  'Activty Type': 'សកម្មភាពជាប្រភេទ',
  'Are there any policies, regulations or other contexts making you difficult to implement your tasks?':
    'តើមានគោលការណ៍ បទបញ្ជាផ្ទៃក្នុង ឬបរិបទណាមួយដែលធ្វើឱ្យអ្នកពិបាកក្នុងការបំពេញការងារនៅក្នុងក្រុមហ៊ុន?',
  'Attendance Assessment': 'ការវាយតម្លៃវត្តមាន',
  'Attendance Score Result': 'លទ្ធផលពិន្ទុចូលរួម',
  Approve: 'យល់ព្រម',
  'Acknowledge Date': 'ថ្ងៃអនុម័ត',
  'Approval Community': 'សហគមន៍អនុម័ត',
  'Approve By': 'អនុម័តដោយ',
  'Assign Team': 'ក្រុមចាត់តាំង',
  'Appraisal Period From Date': 'Appraisal Period From Date',
  'Appraisal Period to Date': 'Appraisal Period to Date',

  // B

  'Bank Account Name': 'ឈ្មោះគណនីធនាគារ',
  'Bachelor Degree': 'បរិញ្ញាបត្រ',
  Broken: 'ខូច',
  'Behavior and Skill Score': 'ឥរិយាបថ និងពិន្ទុជំនាញ',
  'Business or Departmental Functions/Projects/Internal Process': 'មុខងារទាក់ទងនឹងអាជីវកម្ម ឬមុខងាររបស់ផ្នែក/គម្រោង/ដំណើរការផ្ទៃក្នុង',
  Building: 'អាគារ',
  'Bank Name': 'ឈ្មោះធនាគារ',
  'Bank Account Number': 'លេខគណនីធនាគារ',
  'Basic Salary Option': 'ជម្រើសប្រាក់ខែដើម',
  'Birth Address': 'អាស័យដ្ឋានកំណើត',
  'Birth District': 'ស្រុកកំណើត',
  'Birth Province': 'ខេត្តកំណើត',
  'Birth Country Code': 'លេខកូដប្រទេសកំណើត',
  Break: 'សម្រាក',
  'Break Starting Time': 'ចាប់ផ្ដើមម៉ោងសម្រាក',
  'Break Ending Time': 'បញ្ចប់ម៉ោងសម្រាក',
  'Branch Code': 'លេខកូដសាខា',
  'Behavior Assessment': 'ការវាយតម្លៃអាកប្បកិរិយា',
  Back: 'ថយក្រោយ',
  'Behavior Description': 'ការពិពណ៌នាអំពីអាកប្បកិរិយា',
  'Block Leave': 'ច្បាប់សម្រាករយៈពេលយូរ',
  'Basic Salary': 'ប្រាក់ខែគោល',
  'Brief Summary of the course content': 'មាតិការសង្ខេបនៃវគ្គបណ្តុះបណ្តាល',
  'Business Unit Code': 'លេខកូដឯកតាអាជីវកម្ម',
  'Brief Description': 'សង្ខេបការពិពណ៍នាការងារ',
  'Brief Description (Name of External Partner)': 'សង្ខេបការពិពណ៍នាការងារ (ឈ្មោះដៃគូខាងក្រៅ)',
  'Brief Description (Name of Files and Password)': 'ការពិពណ៌នាខ្លី (ឈ្មោះឯកសារ និងពាក្យសម្ងាត់)',
  'Break Time': 'ពេលវេលាសម្រាក',
  'Brief Description (Name of Internal Partner)': 'សង្ខេបការពិពណ៍នាការងារ (ឈ្មោះដៃគូខាងក្នុង)',
  'Branch Changed': 'ផ្លាស់ប្តូរសាខា',

  // C

  Computer: 'កុំព្យូទ័រ',
  Campus: 'សាខា',
  'Condition Change': 'បែបបទផ្លាស់ប្តូរលក្ខខណ្ឌការងារ',
  Cancelled: 'បោះបង់',
  'Change of Working Hour': 'ប្តូរម៉ោងការងារ',
  'Change of Bank Account': 'ផ្លាស់ប្តូរគណនីធនាគារ',
  'Change of National ID Card': 'ផ្លាស់ប្តូរព័ត៍មានអត្តសញ្ញាណប័ណ្ណ',
  'Company Phone Number': 'លេខទូរស័ព្ទក្រុមហ៊ុន',
  'Campus Changed': 'ប្តូរសាខា',
  Confirmation: 'Confirmation',
  'Change In Job Role': 'ផ្លាស់ប្តូរតួនាទីការងារ',
  Child: 'កូន',
  'Change Position': 'ផ្លាស់ប្តូរមុខដំណែង',
  'Change Lanyard': 'ផ្លាស់ប្តូរខ្សែ',
  'Change Department': 'ផ្លាស់ប្តូរនាយកដ្ឋាន',
  'Confirming Objectives Agreed Upon at the Beginning of the Period': 'ហត្ថលេខារបស់បុគ្គលិកដែលទទួលបានកម្មវត្ថុការងារក្នុងដំណាក់កាលដំបូង',
  'Confirming Objectives Agreed at Start of the Beginning Period': 'ហត្ថលេខារបស់បុគ្គលិកដែលទទួលបានកម្មវត្ថុការងារក្នុងដំណាក់កាលដំបូង',
  'Change of Marital Status': 'ផ្លាស់ប្តូរស្ថានភាពអាពាហ៍ពិពាហ៍',
  'Contact Number 2': 'លេខទំនាក់ទំនង ២',
  'Change of Name': 'ផ្លាស់ប្តូរឈ្មោះ',
  'Contact Number': 'លេខទំនាក់ទំនង',
  'Change of Emergency Contact Detail': 'ផ្លាស់ប្តូរព័ត៍មានសម្អិតទំនាក់ទំនងបន្ទាន់',
  'Change of Phone Number': 'ផ្លាស់ប្តូរលេខទូរស័ព្ទ',
  'Change of Address': 'ផ្លាស់ប្តូរអាស័យដ្ឋាន',
  'Change of Date of Birth': 'ផ្លាស់ប្តូរថ្ងៃខែឆ្នាំកំណើត',
  'Confirmed and Unsuccessful Probation Form': 'Confirmed and Unsuccessful Probation Form',
  'Confirmed and Unsuccessful Probation': 'Confirmed and Unsuccessful Probation',
  'Customer Service': 'ការផ្តល់សេវាកម្មទៅអតិថិជន',
  'Completed Name': 'ឈ្មោះអ្នកបញ្ចប់',
  'Completed By': 'បញ្ចប់ដោយ',
  'Committed Start Date': 'ចាប់ផ្តើមប្រប្រឹត្តនៅថ្ងៃទី',
  'Committed End Date': 'បញ្ចប់ប្រប្រឹត្តនៅថ្ងៃទី',
  'Company  Phone No': 'លេខទូរស័ព្ទក្រុមហ៊ុន',
  'Current Address': 'អាស័យដ្ឋានបច្ចុប្បន្ន',
  'Contract Information': 'ព័ត៌មានកិច្ចសន្យា',
  'Contract Made Issue Date': 'ថ្ងៃចេញកិច្ចសន្យា',
  'Clock Time Card No': 'ម៉ោងលេខកាត',
  'Checklist Template Code': 'លេខកូដគំរូបញ្ជីត្រួតពិនិត្យ',
  'Cessation Tasks': 'កិច្ចការបញ្ឈប់',
  'Course Book': 'សៀវភៅសិក្សា',
  'Card No': 'លេខកាត',
  'Commnuication and Address': 'ការប្រាស្រ័យទាក់ទង និងអាស័យដ្ឋាន',
  'Change Dayoff Request Form': 'ពាក្យស្នើសុំផ្លាស់ប្តូរថ្ងៃឈប់សម្រាក',
  'Change Timesheets Request Form': 'ពាក្យស្នើសុំផ្លាស់ប្តូរតារាងពេលវេលាធ្វើការ',
  Career: 'អាជីព',
  'Career Change Request Form': 'ពាក្យស្នើសុំផ្លាស់ប្តូអាជីព',
  'Employee Career Change Request': 'ពាក្យស្នើសុំផ្លាស់ប្តូអាជីព',
  'Engagement Survey': 'ការស្ទង់មតិបុគ្គលិក',
  Condition: 'លក្ខខណ្ឌ',
  'Change Day Off Details': 'ព័ត៌មានលម្អិតនៃការផ្លាស់ប្តូរថ្ងៃឈប់សម្រាក',
  'Changing Reason Remark': 'ព័ត៌មានដែលត្រូវកត់ចំណាំ',
  'Contract Type': 'ប្រភេទនៃកិច្ចសន្យា',
  Closed: 'បានបញ្ចប់',
  'Click here to Files!': 'ចុចទីនេះដើម្បីបញ្ចូលឯកសារ',
  Cancel: 'បោះបង់',
  Close: 'បោះបង់',
  'Change Dayoff Request': 'ពាក្យស្នើសុំផ្លាស់ប្តូរថ្ងៃឈប់សម្រាក',
  Category: 'ប្រភេទ',
  'Change Timesheet Request': 'ពាក្យស្នើសុំផ្លាស់ប្តូរតារាពេលវេលា',
  'Compassionate Leave': 'ច្បាប់សមាជិកគ្រួសារទទួលមរណៈភាព​',
  'Change Day-Off Leave': 'ច្បាប់ផ្លាស់ប្តូរថ្ងៃឈប់សម្រាក',
  'Change Personal Information': 'ផ្លាស់ប្ដូរព័ត៌មានផ្ទាល់ខ្លួន',
  'Change Contact & Emergency Contact': 'ផ្លាស់ប្ដូរលេខទំនាក់ទំនង និងលេខ​ទំនាក់ទំនង​បន្ទាន់',
  'Change Birth Address Information': 'ផ្លាស់ប្ដូរព័ត៌មាននៃទីកន្លែងកំណើត',
  'Change Permanent Address Information': 'ផ្លាស់ប្ដូរព័ត៌មានអាស័យដ្ឋានបច្ចុប្បន្ន',
  'Change Current Address Information': 'ផ្លាស់ប្ដូរព័ត៌មានអាស័យដ្ឋានអចិន្ត្រៃយ៍',
  'Career Change Details': 'ព័ត៌មានលម្អិតអំពីការផ្លាស់ប្តូរអាជីព',
  'Career Code': 'កូដការផ្លាស់ប្ដូរ',
  'Course Information': 'ព័ត៌មានវគ្គបណ្តុះបណ្តាល',
  'Course Date': 'កាលបរិច្ឆេទវគ្គសិក្សា',
  'Course Offered by': 'វគ្គបណ្តុះបណ្តាលផ្តល់ដោយ',
  Conclusion: 'សេចក្តីសន្និដ្ឋាន',
  'Committed Date': 'ថ្ងៃដែលបានប្តេជ្ញាចិត្ត',
  Communication: 'ការប្រាស្រ័យទាក់ទង',
  Completed: 'រួចរាល់',
  'Checking Date': 'ថ្ងៃពិនិត្យ',
  'Checking Time': 'ម៉ោងពិនិត្យ',
  'Completed Date': 'ថ្ងៃបញ្ចប់',
  'Completed Time': 'ម៉ោងបញ្ចប់',
  'Checking Status': 'កំពុងពិនិត្យស្ថានភាព',
  'Contact Details (Phone Number or Email)': 'ព័ត៍មានលម្អិត(លេខទូរសព្ទឫអ៊ីមែល)',
  Cancalled: 'បានលុបចោល',
  Carrer: 'អាជីព',
  Checked: 'បានពិនិត្យ',
  'Checked In': 'ពេលវេលាពិនិត្យចូល',
  'Checked Out': 'ពេលវេលាពិនិត្យចេញ',
  'Checked In Time': 'ម៉ោងចូល',
  'Checked Out Time (Break)': 'ម៉ោងចេញ (សម្រាក)',
  'Checked In Time (Break)': 'ម៉ោងចូល (សម្រាក)',
  'Checked Out Time': 'ម៉ោងចេញ',
  Comments: 'មតិយោបល់',
  'Contract Ending Date': 'ថ្ងៃបញ្ចប់សន្យា',
  'Contract Starting Date': 'ថ្ងៃចាប់ផ្តើមសន្យា',
  'Current Basic Salary': 'ប្រាក់ខែដើមបច្ចុប្បន្ន',
  'Change Shift Request Form': 'ពាក្យស្នើសុំផ្លាស់ប្តូរតារាងពេលវេលាធ្វើការ',
  'Campus Code': 'លេខកូដសាខា',
  'Classroom + Online': 'ថ្នាក់រៀន + អនឡាញ',
  'Committee Approval': 'ការអនុម័តពីគណៈកម្មាធិការ',
  'Check By': 'ពិនិត្យដោយ',
  Custom: 'កែខ្លួនឯង',
  'Course Location': 'ទីតាំងបណ្តុះបណ្តាល',

  // D

  'Date of Missing': 'កាលបរិច្ឆេទអាក់ខាន',
  'Do you want to send notify to your successor?': 'Do you want to send notify to your successor?',
  'Department Transferred': ' ផ្លាស់ប្តូរផ្នែក',
  Demotion: 'Demotion',
  Divorced: 'លែងលះ',
  Demoted: 'ទម្លាក់',
  'Delegate To Name': 'ឈ្មោះអ្នកតំណាង',
  'Delegate To': 'អ្នកតំណាង',
  Dissatified: 'មិនពេញចិត្ត',
  Division: 'អគ្គនាយកដ្ធាន',
  'Division 1': 'ផ្នែកអាជីវកម្ម',
  Delete: 'លុប',
  'DISCIPLINARY-TERMINATION': 'DISCIPLINARY-TERMINATION',
  'Do you need the MJQE sponsor your PhD, Master, Bachelor?': 'តើអ្នកមានតម្រូវការឲ្យក្រុមហ៊ុនឧបត្ថម្ភជាថវិការសម្រាប់ការសិក្សាឧត្តមសិក្សាដែរឬទេ?',
  'During Working Hour': 'ក្នុងអំឡុងពេលម៉ោងធ្វើការ',
  Date: 'កាលបរិច្ឆេទ',
  Department: 'នាយកដ្ឋាន',
  'Daily Clock Time Report': 'របាយការណ៍ម៉ោងប្រចាំថ្ងៃ',
  'Daily Timesheet Matching Report': 'របាយការណ៍តារាងពេលវេលាប្រចាំថ្ងៃ',
  'Daily Summary Working Hour Report': 'របាយការណ៍សង្ខេបម៉ោងការងារប្រចាំថ្ងៃ',
  'Daily Attendance KPI Report': 'របាយការណ៍វត្តមានKPIប្រចាំថ្ងៃ',
  'Daily Overtime Summary Report': 'របាយការណ៍ថែមម៉ោងប្រចាំថ្ងៃ',
  'Disciplinary Record': 'កំណត់ត្រាវិន័យ',
  Dashboards: 'ផ្ទាំងព័ត៌មាន',
  Default: 'លំនាំដើម',
  'Date Of Birth': 'ថ្ងៃខែឆ្នាំកំណើត',
  'Date of Birth': 'ថ្ងៃខែឆ្នាំកំណើត',
  District: 'ស្រុក',
  'Division Code': 'លេខកូដផ្នែក',
  'Department Code': 'លេខកូដនាយកដ្ឋាន',
  Draft: 'សេចក្ដីព្រាង',
  Disposed: 'ច្រានចោល',
  Dispose: 'ច្រានចោល',
  'Day-Off': 'ថ្ងៃ​ឈប់សម្រាក',
  'Do you want to delete file?': 'តើអ្នកចង់លុបឯកសារទេ?',
  'Drop Files': 'បញ្ចូលឯកសារ',
  'Date of the Incident': 'កាលបរិច្ឆេទនៃឧប្បត្តិហេតុ',
  'Description of the Incident': 'ការពិពណ៌នាអំពីឧប្បត្តិហេតុ',
  'Disciplinary Details': 'ព័ត៌មានលម្អិតអំពីវិន័យ',
  Descriptions: 'មូលហេតុ',
  'Disciplinary action Policy The employee shall be': 'គោលនយោបាយសកម្មភាពវិន័យ និយោជិតត្រូវមាន',
  Disagree: 'មិនយល់ស្រប',
  'Document Date': 'កាលបរិច្ឆេទឯកសារ',
  Description: 'ការពិពណ៌នា',
  'Duties in Job Description and Other Tasks': 'ទំនួលខុសត្រូវ ក្នុងការពិពណ៍នាការងារ និងកិច្ចការផ្សេងៗ',
  Documents: 'ចំនួនឯកសារស្នើសុំ',
  'Document No': 'លេខឯកសារ',
  'Document Type': 'ប្រភេទឯកសារ',
  'Daily Attendance Report On': 'របាយការណ៍ម៉ោងចេញចូលរបស់បុគ្គលិក',
  'Due Date': 'ថ្ងៃកំណត់',
  'Deduction Amount': 'ទឹកប្រាក់ដែលបានកាត់',
  'Description of Chronological Events': 'ពណ៌នាអំពីឧប្បត្តិហេតុតាមលំដាប់លំដោយ​ នៃពេលវេលា',
  'Describe what you like most during your employment': 'រៀបរាប់អ្វីដែលអ្នកពេញចិត្តបំផុតក្នុងពេលអ្នកបំពេញការងារ',
  'Describe what you like least during your employment': 'រៀបរាប់អ្វីដែលអ្នកពេញចិត្តតិចបំផុតក្នុងពេលអ្នកបំពេញការងារ',
  'Delegate Approval': 'ការអនុម័តសំណើរ',
  'Disciplinary Action Code': 'ក្រម​ប្រតិបត្តិ​វិន័យ',
  'Day Off Entitlement Balance': 'កំណត់ត្រាសិទ្ធិថ្ងៃឈប់សម្រាក',
  'Document Status': 'ស្ថានភាពឯកសារ',
  DEFAULT: 'ផ្ញើទៅកាន់ប្រធានគ្រប់គ្រងផ្ទាល់',
  Delegate: 'អ្នកតំណាង',
  Day: 'ថ្ងៃ',
  'Degree Sponsorship Request Form': 'ទម្រង់ស្នើសំុឧបត្ថមការសិក្សាឧត្តមសិក្សា',

  // E

  'Evening Hour': 'ម៉ោងល្ងាច',
  'Employee Feedback Survey': 'Employee Feedback Survey',
  'Expired Date': 'កាលបរិច្ឆេទហួសកំណត់អត្តសញ្ញាណប័ណ្ណ',
  'Employee Engagement Survey': 'ការស្ទង់មតិបុគ្គលិក',
  External: 'ខាងក្រៅ',
  'End Of Probation Details': 'End Of Probation Details',
  'Event Date': 'ព្រឹត្តិការណ៍',
  'Employee’s Comment': 'មតិយោបល់បុគ្គលិក',
  'Employee Training Registration': 'ការចុះឈ្មោះបណ្តុះបណ្តាលបុគ្គលិក',
  "Employee's Department": "Employee's Department",
  'EMPLOYEE DISCIPLINARY': 'EMPLOYEE DISCIPLINARY',
  'EMPLOYEE DISCIPLINARY-2': 'EMPLOYEE DISCIPLINARY-2',
  'Employee Type': 'ប្រភេទបុគ្គលិក',
  'Employee Category': 'ផ្នែកបុគ្គលិក',
  'Employee Level': 'កម្រិតបុគ្គលិក',
  'Employee Department Username': 'ឈ្មោះនាយកដ្ឋានបុគ្គលិក',
  'Estimated End Date': 'កាលបរិច្ឆេទបញ្ចប់',
  'Emphasize the 3 most important roles & responsibilities of your position': 'សូមបញ្ជាក់អំពីការទទួលខុសត្រូវចម្បងសំខាន់ៗរបស់អ្នកឲ្យបាន៣ចំនុច',
  'Evening Break (Minute)': 'សម្រាកពេលល្ងាច (នាទី)',
  'Evening break no of minute': 'សម្រាកពេលល្ងាច (នាទី)',
  'Evening Starting Time': 'ពេលវេលាចាប់ផ្តើមពេលល្ងាច',
  'Evening Ending Time': 'ពេលវេលាបញ្ចប់ពេលល្ងាច',
  'EMPLOYEE INCIDENT TO ER': 'ផ្ញើទៅកាន់ផ្នែកធនធានមនុស្ស',
  'End Of Contract Notice Day': 'ថ្ងៃបញ្ចប់កិច្ចសន្យា',
  'End Of Contract Notice Pay Type': 'ដំណឹងអំពីការបញ្ចប់កិច្ចសន្យា ប្រភេទបង់ប្រាក់',
  'Employee Name': 'ឈ្មោះបុគ្គលិក',
  'End Probation Request Form': 'ពាក្យស្នើសុំបញ្ចប់ការសាកល្បង',
  'End Probation Request': 'ពាក្យស្នើសុំបញ្ចប់ការសាកល្បង',
  'Employment Certificate Request Form': 'ពាក្យស្នើសុំវិញ្ញាបនបត្រការងារ',
  'External Training Request Form': 'ពាក្យស្នើសុំការបណ្តុះបណ្តាលក្រៅស្ថាប័ន',
  'External Training Request': 'ពាក្យស្នើសុំការបណ្តុះបណ្តាលខាងក្រៅ',
  'Employee Details': 'ព័ត៌មានលម្អិតរបស់បុគ្គលិក',
  'Ending Time': 'ម៉ោងបញ្ចប់',
  'Emergency Contact Phone No': 'លេខទំនាក់ទំនងពេលមានបញ្ហាបន្ទាន់',
  'Emergency Contact Name': 'ឈ្មោះទំនាក់ទំនងពេលមានបញ្ហាបន្ទាន់',
  Email: 'អ៊ីម៉ែល',
  'Employee ID Number': 'លេខសំគាល់បុគ្គលិក',
  'Employee ID': 'លេខសំគាល់បុគ្គលិក',
  'Employee No': 'លេខសំគាល់បុគ្គលិក',
  'Ending Date': 'ថ្ងៃបញ្ចប់',
  'Emergency Phone Number': 'លេខទំនាក់ទំនងពេលមានបញ្ហាបន្ទាន់',
  'Extension No': 'លេខបន្ថែម',
  'Employee Information': 'ព័ត៌មានបុគ្គលិក',
  'Employee Appraisal Request': 'សំណើវាយតម្លៃបុគ្គលិក',
  'Exceed expectation': 'លើសពីការរំពឹងទុក',
  'Exceeds Expectation': 'លើសការរំពឹងទុក',
  'Employee Scholarship Request': 'ពាក្យស្នើសុំអាហារូបករណ៍',
  'Employee End Probation': 'និយោជិតបញ្ចប់ការសាកល្បង',
  'Effective Date': 'កាល​បរិច្ឆេទ​មាន​ប្រសិទ្ធភាព',
  'Employment Certificate Request': 'ពាក្យស្នើសុំវិញ្ញាបនបត្រការងារ',
  'End Date': 'ថ្ងៃបញ្ចប់',
  'Employee Incident Request': 'កំណត់ត្រាឧប្បត្តិហេតុរបស់និយោជិក',
  'Employee Disciplinary Form': 'កំណត់ត្រាវិន័យរបស់និយោជិត',
  'Disciplinary Action Request': 'កំណត់ត្រាវិន័យរបស់និយោជិត',
  'Employee Training Questionnaire': 'កម្រងសំណួរសម្រាប់ការបណ្តុះបណ្តាលបុគ្គលិក',
  'Employee Handover Files': 'ឯកសារបញ្ជូនការងារបុគ្គលិក',
  'External Relationship/Partnership Contact': 'ទំនាក់ទំនងដៃគូរខាងក្រៅ',
  'Employee Exit Clearance Form': 'បញ្ជីត្រួតពិនិត្យឯកសារនិងព័ត៌មានបុគ្គលិកលាឈប់',
  'Employee Exit Clearance': 'បញ្ជីត្រួតពិនិត្យឯកសារនិងព័ត៌មានបុគ្គលិកលាឈប់',
  'Employee Visa Expire In 30 Days': 'ទិដ្ឋាការបុគ្គលិកជនបរទេសជិតហួតកាលកំណត់ប្រើប្រាស់ក្នុងរយៈពេល ៣០ ថ្ងៃ',
  'Employee Worksheets': 'ប្រអប់សិក្សាបុគ្គលិក',
  'Employee Contracts Expire In 60 Days': 'កុងត្រាការងាររបស់បុគ្គលិកជិតហួតកាលកំណត់ប្រើប្រាស់ក្នុងរយៈពេល ៦០ ថ្ងៃ',
  'Employee Work Permits Expire In 30 Days': 'សៀវភៅការងាររបស់បុគ្គលិកជនបរទេសជិតហួតកាលកំណត់ប្រើប្រាស់ក្នុងរយៈពេល ៣០ ថ្ងៃ',
  'Employee Work Books Expire In 30 Days': 'សៀវភៅការងាររបស់បុគ្គលិកជិតហួតកាលកំណត់ប្រើប្រាស់ក្នុងរយៈពេល ៣០ ថ្ងៃ',
  'Employee Cessation Form': 'បែបបទបញ្ឈប់ការងារ',
  'Employee Payroll Histories': 'ប្រវត្តិប្រាក់ខែបុគ្គលិក',
  'Evening (In)': 'ពេលល្ងាច (ចូល)',
  'Evening (Out)': 'ពេលល្ងាច (ចេញ)',
  Employee: 'បុគ្គលិក',
  Evening: 'ពេលល្ងាច',
  'Employee Satisfaction Form': 'ការស្ទង់មតិការពេញចិត្តប្រធានផ្នែក',
  'Employee Exit Interview': 'សំភាសន៍បុគ្គលិកលាលែងពីការងារ',
  'Employee Disciplinary Request': 'សំណើការប្រកាន់ប្រយោលបុគ្គលិក',
  'Employee Leave Entitlement Record': 'កំណត់ត្រាសិទ្ធិការចុះឈ្មោះនៃការលុបចោលបុគ្គលិក',
  'Expire Date': 'ថ្ងៃផុតកំណត់',
  'Employee Training Request': 'សំណើសម្រាប់ការបណ្តុះបណ្តាលបុគ្គលិក',
  'External Training Report': 'ទម្រង់កត់ត្រាវគ្គបណ្តុះបណ្តាលខាងក្រៅ',
  'External Scholarship Request': 'External Scholarship Request',

  // F

  'Full Time': 'ពេញម៉ោង',
  'Final Grade': 'កម្រិតនៃការវាយតម្លៃចុងក្រោយ',
  'Final Score': 'ពិន្ទុសរុប',
  'Financial/Business Performance': 'ប្រតិបត្តិការហិរញ្ញវត្ថុ និងអាជីវកម្ម',
  'Finance Department': 'Finance Department',

  'First Name in Latin': 'នាមខ្លួន ជាអក្សរឡាតាំង',
  'First Name in Khmer': 'នាមខ្លួន ជាអក្សរខ្មែរ',
  'Finance Department Username': 'ឈ្មោះនាយកដ្ឋានហិរញ្ញវត្ថុ',
  'For Human Resources Only': 'សម្រាប់ផ្នែកធនធានមនុស្សបំពេញតែប៉ុណ្ណោះ',
  Files: 'ឯកសារ',
  'First Priority Skills': 'ជំនាញអាទិភាពទី១',
  'First Priority Remark': 'ការកំណត់សម្គាល់អាទិភាពទី១',
  'First Name': 'នាមត្រកូល',
  'First Name 2': 'នាមត្រកូល 2',
  'From Worksheet Code': 'មកពីលេខកូដក្រុមវេនធ្វើការ',
  Functions: 'មុខងារ',
  From: 'ចាប់ពីថ្ងៃ',
  "FINAL REVIEW: Appraiser's Comments & Overall Performance Results": 'ត្រួតពិនិត្យឡើងវិញចុងក្រោយ៖ យោបល់របស់អ្នកវាយតម្លៃ និងលទ្ធផលការងារទូទៅ',
  'Final Appraisal Score': 'ពិន្ទុវាយតម្លៃចុងក្រោយ',
  'Final Appraisal Grade': 'កម្រិតនៃការវាយតម្លៃចុងក្រោយ',
  'Final Written Warning': 'ការព្រមានជាលាយលក្ខណ៍អក្សរចុងក្រោយ',
  Female: 'ស្រី',
  Flexibility: 'ភាពបត់បែន',
  'File Description': 'ការពិពណ៌នាឯកសារ',
  'From Time': 'ចាប់ពីម៉ោង',
  'Full Day': 'ពេញមួយថ្ងៃ',
  Friday: 'ថ្ងៃសុក្រ',
  'Final Written Warning with Suspended Working': 'ការព្រមានសរសេរក្នុងចុងក្រោយជាមួយការបញ្ឈប់ការងារ',

  // G

  General: 'ទូទៅ',
  'Gross Pay': 'ប្រាក់ឈ្នួលសរុប',
  Gender: 'ភេទ',
  'Gross Pay Amount': 'Gross Pay Amount',
  'Gross Pay Amount (2nd)': 'Gross Pay Amount (2nd)',
  Group: 'ក្រុម',

  // H

  'Half-Full Time': 'ពាក់កណ្តាលពេញម៉ោង',
  'Human Resources Department': 'Human Resources Department',
  'Handover Committees': 'គណៈកម្មាធិការ',
  'HR Department Username': 'ឈ្មោះនាយកដ្ឋានធនធានមនុស្ស',
  'Hard Documents such as Binder/Box File/Key Documents/Referent Materials (Attached if possible)':
    'ឯកសារច្បាប់ដើម ដូចជា​​ឯកសារចង/ប្រអប់/​ឯកសារគន្លឹះ/​ឯកសារយោង(ភ្ជាប់មកជាមួយប្រសិនបើមាន)',
  'HOD Status': 'ការសម្រេចចិត្តប្រធានផ្នែក',
  "HoD's Status": 'ការសម្រេចចិត្តប្រធានផ្នែក',
  "HoD's Comment": 'មតិយោបល់ប្រធានផ្នែក',
  Home: 'ទំព័រដើម',
  'HR Conclusion No': 'លេខការសន្និដ្ឋាន HR',
  'Hard Skills Assessment': 'ការវាយតម្លៃជំនាញ',
  High: 'ខ្ពស់',
  Hard: 'ខ្លាំង',
  'How will this training benefit you and the company?': 'តើ​វគ្គ​បណ្តុះបណ្តាល​នេះ​ផ្តល់​អត្ថប្រយោជន៍​អ្វីខ្លះ​ដល់​អ្នក និង​ក្រុមហ៊ុន​?',
  'Hr Induction Assessment Test': 'Hr Induction Assessment Test',
  'Hr Induction Assessment Test Employee': 'Hr Induction Assessment Test Employee',
  'HR Induction Assessment (E)': 'HR Induction Assessment (E)',
  'HR Induction Assessment (C)': 'HR Induction Assessment (C)',
  'HR Induction Assessment Test (E)': 'HR Induction Assessment Test (E)',
  'HR Induction Assessment Test (C)': 'ធ្វើតេស្តលើកម្រងសំណួរវគ្គតម្រង់ទិសសម្រាប់បុគ្គលិកថ្មី',

  // I

  'Input Weightage % (KPI)': 'Input Weightage % (KPI)',
  Initialed: 'Initialed',
  'In House Staff Leave': 'ច្បាប់សម្រាកសម្រាប់បុគ្គលិកស្នាក់នៅសាលា',
  'In House Leave': 'ច្បាប់សម្រាកសម្រាប់បុគ្គលិកស្នាក់នៅសាលា',
  'Information The Person You Evaluate': 'Information The Person You Evaluate',
  'Issued Date': 'កាលបរិច្ឆេទចេញកំណត់អត្តសញ្ញាណប័ណ្ណ',
  'ID Card Number': 'លេខអត្តសញ្ញាណប័ណ្ណ',
  Introduction: 'សេចក្តីផ្តើម',
  'INTRODUCTION OF TERMINATION': 'INTRODUCTION OF TERMINATION',
  Internal: 'Internal',
  Individual: 'បុគ្គល',
  'In Working Hour': 'ក្នុងម៉ោងធ្វើការ',
  'ID Card Printing Request': 'ID Card Printing Request',
  'Information Detail': 'ព័ត៌មានលំអិត',
  'I accept receive appraisal': 'ខ្ញុំទទួលយកការវាយតម្លៃ',
  'I was given feedback and coaching throughout my evaluation': 'ខ្ញុំទទួលបានការឱ្យយោបល់ និងណែនាំអំពីការវាយតម្លៃរបស់ខ្ញុំ។',
  'Information Technology Department': 'Information Technology Department',
  'Interview Status': 'ស្ថានភាពសម្ភាសន៍',
  'Information Khmer': 'ព័ត៌មានជាខ្មែរ',
  Information: 'ព័ត៌មាន',
  'IT Department Username': 'ឈ្មោះនាយកដ្ឋាន IT',
  'International Travel': 'ការធ្វើដំណើរលក្ខណៈអន្តរជាតិ',
  'Incident Record': 'កំណត់ត្រាឧប្បត្តិហេតុ',
  'Incident Report': 'កំណត់ត្រាឧប្បត្តិហេតុ',
  'ID Card No': 'លេខកាតសម្គាល់ខ្លួន',
  'Information of Staff Family Requesting for Scholarship': 'ព័ត៌មាននៃគ្រួសារបុគ្គលិកស្នើសុំអាហារូបករណ៍',
  'Incident Details': 'ព័ត៌មានលម្អិតអំពីឧប្បត្តិហេតុ',
  'Incident Result': 'លទ្ធផលហេតុការណ៍',
  'Introduction Of Termination': 'ការណែនាំអំពីការលាលែង',
  'Id Card No': 'លេខកាតសម្គាល់',
  'Internal Training Request Form': 'ពាក្យស្នើសុំការបណ្តុះបណ្តាលក្នុងស្ថាប័ន',
  'Initial By': 'ហត្ថលេខាសង្ខេបដោយ',
  'Incident End Date': 'កាលបរិច្ឆេទបញ្ចប់ឧប្បត្តិហេតុ',
  'Incident Start Date': 'កាលបរិច្ឆេទចាប់ផ្តើមឧប្បត្តិហេតុ',

  // J

  'Job Abandonment': 'Job Abandonment',
  'Job Title': 'តួនាទី',
  'Job Off-boarding Checklist': 'បញ្ជីត្រួតពិនិត្យថ្ងៃឈប់ធ្វើការ',
  'Job On-boarding Checklist': 'បញ្ជីត្រួតពិនិត្យថ្ងៃចូលធ្វើការ',
  'Job Requisition Request Form': 'ពាក្យស្នើសុំជ្រើសរើសបុគ្គលិក',
  'Join Date': 'ថ្ងៃចាប់ផ្ថើម',
  'Job Information': 'ព័ត៌មានការងារ',
  'Job Description': 'ពណ៌នាការងារ',
  'Job Education': 'ការងារការអប់រំ',
  'Job Requisition Details': 'ព័ត៌មានលម្អិតអំពីសំណើការងារ',
  'Job Education Qualification': 'ការងារ ការអប់រំ គុណសម្បត្តិ',
  'Job Requisition': 'ការងារសំណើ',
  'Job Onboarding Task': 'ភារកិច្ចចូលរួមការងារ',
  'Joined Date': 'ថ្ងៃចូលបម្រើការងារ',
  'Job Announcement Doc No': 'ចំនួនដំណឹងឯកសារការងារ',
  'Job Handover Request': 'បញ្ជីត្រួតពិនិត្យផ្ទេរឯកសារនិងភារកិច្ច',
  'Job Handover Request Form': 'បញ្ជីត្រួតពិនិត្យផ្ទេរឯកសារនិងភារកិច្ច',
  'Job Handover Form': 'បញ្ជីត្រួតពិនិត្យផ្ទេរឯកសារនិងភារកិច្ច',

  // K

  'Key Performance Indicator (KPI)': 'សូចនាករសមិទ្ធកម្មគន្លឹះ (KPI)',
  KPI: 'KPI',
  'Knowledge, Skill, And Experience Qualification': 'ចំណេះដឹង ជំនាញ​ និង បទពិសោធន៍',
  'Khmer Name': 'ឈ្មោះខ្មែរ',
  'KPI Score': 'ពិន្ទុ KPI',
  'Key Internal Relationship/Partnership Contact': 'ដៃគូទំនាក់ទំនងសំខាន់ៗខាងក្នុង',

  // L

  'Line manger ID': 'Line manger ID',
  'Line manger ID 2': 'Line manger ID 2',
  'Line Manager Name 2': 'Line Manager Name 2',
  'Learning Channel': 'មធ្យោបាយសិក្សា',
  'Learning Type': 'ប្រភេទនៃការសិក្សា',
  'Local Training': 'ក្នុងប្រទេស',
  Lost: 'បាត់',
  'Line Code': 'Line Code',
  'Line Manager': 'អ្នកគ្រប់គ្រង',
  'Line Manager Name (2)': 'ឈ្មោះអ្នកគ្រប់គ្រង (២)',
  'Line Manager (2)': 'អ្នកគ្រប់គ្រង (២)',
  'Last Working Day': 'ថ្ងៃធ្វើការចុងក្រោយ',
  'Line Manager ID': 'លេខអ្នកគ្រប់គ្រង',
  'Line Manager ID (2)': 'លេខអ្នកគ្រប់គ្រង (២)',
  'Last Name in Latin': 'នាមត្រកូល ជាអក្សរឡាតាំង',
  'Last Name in Khmer': 'នាមត្រកូល ជាអក្សរខ្មែរ',
  'Library Department Username': 'ឈ្មោះនាយកដ្ឋានបណ្ណាល័យ',
  'Length Of Education': 'រយៈពេលសិក្សា',
  'Level/Grade': 'កម្រិត/ថ្នាក់',
  Local: 'ក្នុងប្រទេស',
  'Local Travel': 'ការធ្វើដំណើរក្នុងស្រុក',
  'Leave For': 'ច្បាប់សម្រាប់',
  'Leave Option': 'ជម្រើសនៃការចាកចេញ',
  'Last Change Career Date': 'ថ្ងៃប្តូរការងារចុងក្រោយ',
  'Last Name 2': 'នាមខ្លួន 2',
  'Last Name': 'នាមខ្លួន',
  'Leave Request Form': 'ពាក្យស្នើសុំអនុញ្ញាតច្បាប់ឈប់សម្រាក',
  'Leave Details': 'ព័ត៌មានលម្អិតនៃការសុំច្បាប់',
  'Line Manager Name': 'ឈ្មោះអ្នកគ្រប់គ្រង',
  'Level Of Training Priority': 'កម្រិតអាទិភាពនៃការបណ្តុះបណ្តាល',
  Low: 'ទាប',
  Leave: 'ពាក្យស្នើសុំអនុញ្ញាតច្បាប់ឈប់សម្រាក',
  'Long Sick Leave': 'ការឈប់សម្រាកឈឺយូរ',
  'Line Manager No': 'លេខកូដអ្នកគ្រប់គ្រង',
  Location: 'ទីតាំង',
  Leadership: 'ភាពជាអ្នកដឹកនាំ',
  'Leave Time': 'ម៉ោងចេញ',
  'Last Working Date': 'ថ្ងៃធ្វើការចុងក្រោយ',
  'Last working Date': 'ថ្ងៃធ្វើការចុងក្រោយ',
  'Loan Amount': 'ចំនួនប្រាក់កម្ចី',
  'Loan Settlement Amount': 'ចំនួនទឹកប្រាក់ទូទាត់ប្រាក់កម្ចី',
  'Leave Before or After long Holiday': 'ច្បាប់មុនក្រោយថ្ងៃឈប់សម្រាករយៈពេលវែង',

  // M

  'Morning Hour': 'ម៉ោងពេលព្រឹក',
  'My appraiser has discussed my developmental plans with me': 'អ្នកវាយតម្លៃខ្ញុំបានពិភាក្សាជាមួយនឹងខ្ញុំពីផែនការអភិវឌ្ឍរបស់ខ្ញុំ',
  'Mail Content': 'កំណត់ចំណាំ',
  'Master Degree': 'បរិញ្ញាបត្រជាន់ខ្ពស់',
  'Mid-Year Annual Review': 'Mid-Year Annual Review',
  Married: 'រៀបការរួច',
  'My appraiser and I conducted review': 'អ្នកវាយតម្លៃខ្ញុំ និងខ្ញុំបានធ្វើការវាយតម្លៃការងាររបស់ខ្ញុំ។',
  'Mengly J. Quach Library': 'Mengly J. Quach Library',
  'Morning Break (Minute)': 'សម្រាកពេលព្រឹក (នាទី)',
  'Morning break no of minute': 'សម្រាកពេលព្រឹក (នាទី)',
  'Morning Starting Time': 'ម៉ោងចាប់ផ្តើមពេលព្រឹក',
  'Morning Ending Time': 'ពេលវេលាបញ្ចប់ពេលព្រឹក',
  'Monthly Attendance KPI Report': 'របាយការណ៍វត្តមានKPIប្រចាំខែ',
  'Marital Status': 'ស្ថានភាពអាពាហ៍ពិពាហ៍',
  Morning: 'ពេលព្រឹក',
  'Measures Metrics': 'ការវាស់វែង',
  'Meet expectation': 'សម្រេចបានតាមការរំពឹងទុក',
  'Mission Leave': 'ច្បាប់បេសកកម្ម',
  Medium: 'មធ្យម',
  'Maternity Leave': 'ច្បាប់លំហែមាតុភាព',
  'Marriage Leave': 'ច្បាប់អាពាហ៍ពិពាហ៍',
  Male: 'ប្រុស',
  'Misconduct Description': 'ការពិពណ៌នាអំពីអាកប្បកិរិយាខុស',
  Management: 'ការគ្រប់គ្រង',
  'My Task Activity': 'ឯកសារភារកិច្ចដែលត្រូវបំពេញ',
  'My Approval Document': 'ឯកសារស្នើសុំសំណើអនុម័ត',
  'My Request Approval': 'ការស្នើសុំរបស់ខ្ញុំ',
  'Morning (In)': 'ពេលព្រឹក (ចូល)',
  'Morning (Out)': 'ពេលព្រឹក (ចេញ)',
  Monday: 'ថ្ងៃច័ន្ទ',
  Major: 'មុខជំនាញ',

  // N

  'Night Hour': 'ម៉ោង​យប់',
  'Night Shift': 'វេនយប់',
  'National ID Card Issue Date': 'កាលបរិច្ឆេទចេញកំណត់អត្តសញ្ញាណប័ណ្ណ',
  'Night Break': 'សម្រាកពេលយប់',
  'National ID Card Expired Date': 'កាលបរិច្ឆេទហួសកំណត់អត្តសញ្ញាណប័ណ្ណ',
  'New Personal Information': 'ព័ត៌មានផ្ទាល់ខ្លួនថ្មី',
  'New Employee Announcement': 'New Employee Announcement',
  No: 'ទេ',
  'New Employee': 'បុគ្គលិកថ្មី',
  'Name in Latin': 'ឈ្មោះជាអក្សរឡាតាំង',
  'Name in Khmer': 'ឈ្មោះជាអក្សរខ្មែរ',
  Nationality: 'សញ្ជាតិ',
  'National ID Card': 'លេខអត្តសញ្ញាណប័ណ្ណ',
  'National ID Issue Date': 'ថ្ងៃចេញ​អត្តសញ្ញាណប័ណ្ណ​',
  'NSSF No': 'លេខ ប.ស.ស',
  'Notice Day or Month': 'ការជូនដំណឹងថ្ងៃឬខែ',
  Normal: 'ធម្មតា',
  'Notice Day': 'ថ្ងៃជូនដំណឹង',
  'No Of Day': 'ចំនួនថ្ងៃ',
  'No Of Hour': 'ចំនួនម៉ោង',
  Name: 'ឈ្មោះ',
  'No. of Days': 'ចំនួនថ្ងៃ',
  'No. of Hours': 'ចំនួនម៉ោង',
  'No. of Minutes': 'ចំនួននាទី',
  'No. Of Working Hours': 'ចំនួននៃម៉ោងធ្វើការ',
  'No. Of Break Hours': 'ចំនួននៃម៉ោងសម្រាក',
  'Nationality Code': 'លេខកូដសញ្ជាតិ',
  'Net Pay': 'Net Pay',
  New: 'បង្កើតថ្មី',
  'No, cancel!': 'ទេ,បោះបង់!',
  'Nothing has been done': 'គ្មានអ្វីត្រូវបានធ្វើទេ',
  'No. Of Day(s)': 'ចំនួនថ្ងៃ',
  'New Position Code': 'លេខកូដតួនាទីថ្មី',
  'New Basic Salary': 'ប្រាក់ខែគោលថ្មី',
  'New Division Code': 'លេដកូដផ្នែកថ្មី',
  'New Department Code': 'លេខកូដនាយកដ្ឋានថ្មី',
  'New Line Manager No': 'លេខកូដអ្នកគ្រប់គ្រងថ្មី',
  'New Line Manager Name': 'ឈ្មោះអ្នកគ្រប់គ្រងថ្មី',
  'Name of Course': 'ឈ្មោះវគ្គបណ្តុះបណ្តាល',
  'Number of Days': 'ចំនួនថ្ងៃ',
  'Name of Successor': 'ឈ្មោះអ្នកទទួលការងារបន្ត',
  'New Job Onboarding Checklist': 'បញ្ជីត្រួតពិនិត្យឯកសារនិងព័ត៌មានបុគ្គលិកថ្មី',
  Night: 'ពេលយប់',
  'No. Of Working Day': 'ចំនួនថ្ងៃនៃការធ្វើការ',
  'No. Of Working Time': 'ចំនួនម៉ោងនៃការធ្វើការ',
  'No. Of Late Day': 'ចំនួននៃការយឺត',
  'No. Of Leave Day': 'ចំនួននៃការឈប់',
  'Night (In)': 'ពេលយប់ (ចូល)',
  'Night (Out)': 'ពេលយប់ (ចេញ)',
  'No. Of Evening Working Hours': 'ចំនួនម៉ោងធ្វើការនៅពេលល្ងាច',
  'Notice Option': 'ជម្រើសជូនដំណឹង',
  'Notice Date': 'ថ្ងៃជូនដំណឹង',
  'No of day': 'ចំនួនថ្ងៃ',
  'Net Pay Amount': 'Net Pay Amount',
  'No of Day': 'ចំនួនថ្ងៃ',

  // O

  'Old Personal Information': 'ព័ត៌មានផ្ទាល់ខ្លួនចាស់',
  Outsource: 'Outsource',
  'Oversea Training': 'ក្រៅប្រទេស',
  'Out Working Hour': 'ក្រៅម៉ោងធ្វើការ',
  Oversea: 'ក្រៅប្រទេស',
  Other: 'ផ្សេងៗ',
  'Outstanding-Excellent or Accomplished beyond expectations by 50% or more.': 'សម្រេចបានល្អឥតខ្ចោះ ឬលើសការរំពឹងទុកចាប់ពី 50%',
  Ordinary: 'ធម្មតា',
  'Overtime Option': 'ជម្រើសបន្ថែមម៉ោង',
  'Overtime Request Form': 'ពាក្យស្នើសុំធ្វើការថែមម៉ោង',
  'Overtime History Record': 'ប្រវត្តិវត្តមានម៉ោងចេញចូលធ្វើការថែមម៉ោង',
  'Overtime Request Detail': 'ព័ត៌មានលម្អិតនៃការស្នើសុំបន្ថែមម៉ោង',
  'Overtime Type': 'ប្រភេទនៃការថែមម៉ោង',
  'Office Phone Number': 'លេខទូរស័ព្ទការិយាល័យ',
  'Overall Rating Results': 'លទ្ធផលវាយតម្លៃសរុប',
  Open: 'បើក',
  'Outstanding/Excellence': 'ឧត្តមភាព/ឆ្នើម',
  Outstanding: 'ឆ្នើម',
  'Onboarding Tasks': 'ភារកិច្ចចូលរួម',
  'Office Phone No': 'លេខទូរស័ព្ទការិយាល័យ',
  Online: 'សិក្សាអនឡាញ',
  'Other remarks(if any)': 'ចំណាំផ្សេងៗ (ប្រសិនបើមាន)',

  // P

  'Please select the school': 'សូមជ្រើសរើសសាលា',
  'Part Time': 'ក្រៅម៉ោង',
  'Print Option': 'ជម្រើសបោះពុម្ព',
  'Pending Initial': 'Pending Initial',
  'Please complete the Engagement Survey Form.': 'សូមបំពេញបែបបទស្ទង់មតិការចូលរួម',
  'Engagement Survey Open! Please complete the company engagement survey between':
    'ការស្ទង់មតិអំពីការចូលរួមរបស់ក្រុមហ៊ុនបានបើកហើយ! សូមបំពេញការស្ទង់មតិអំពីការចូលរួមរបស់ក្រុមហ៊ុនរវាង',
  Permitted: 'អនុញ្ញាត',
  'Phd Degree': 'បណ្ឌិត',
  'Physical + Online': 'សិក្សាផ្ទាល់ + សិក្សាអនឡាញ',
  Physical: 'សិក្សាផ្ទាល់',
  'Physical Classroom': 'ថ្នាក់រៀនផ្ទាល់',
  PIP: 'PIP',
  Probation: 'សាកល្បង',
  'Position Changed': 'ប្តូរតួនាទី',
  Promotion: 'តំឡើងតួនាទី',
  Promoted: 'Promoted',
  'Phone Number': 'លេខទូរស័ព្ទ',
  'Permanent Address in Khmer': 'អាស័យដ្ឋានជាអក្សរខ្មែរ',
  'Passport Issued Date': 'ថ្ងៃចេញលិខិតឆ្លងដែន',
  'Place of Birth': 'ទីកន្លែងកំណើត',
  'Place of Birth Address in Khmer': 'ទីកន្លែងកំណើត ជាអក្សរខ្មែរ',
  'Probation Month': 'ខែសាកល្បង',
  'Payroll Pay Option': 'ជម្រើសបើកប្រាក់បៀវត្សរ៍',
  Page: 'ទំព័រ',
  'Place Of Course': 'ទីកន្លែងនៃវគ្គសិក្សា',
  'Present Address': 'អាស័យដ្ឋានបច្ចុប្បន្ន',
  'Payroll Policy Code': 'លេខកូដគោលប្រាក់ខែ',
  'Payroll Bank': 'ធនាគារប្រាក់ខែ',
  'Payroll Bank Account No': 'លេខគណនីធនាគារសម្រាប់ប្រាក់ខែ',
  'Payroll Pay By': 'បើកប្រាក់ខែដោយ',
  'Personal Phone No': 'លេខទូរស័ព្ទ',
  'Personal Email': 'អ៊ីម៉ែល',
  'Personal Address': 'អាស័យដ្ឋាន',
  'Phone No': 'លេខទូរស័ព្ទ',
  'Personal Information Change Request Form': 'ពាក្យស្នើសុំផ្លាស់ប្ដូរព័ត៌មានផ្ទាល់ខ្លួន',
  'Personal Info. Change Request Form': 'ពាក្យស្នើសុំផ្លាស់ប្ដូរព័ត៌មានផ្ទាល់ខ្លួន',
  Performance: 'សមិទ្ធិផលការងារ',
  Payroll: 'ប្រាក់បៀវត្សរ៍',
  'Payroll History Record': 'ប្រវត្តិការបើកប្រាក់បៀវត្សរ៍',
  'Passport No': 'លេខលិខិតឆ្លងដែន',
  'Permanent Address': 'អាស័យដ្ឋាន​បច្ចុប្បន្ន',
  'Permanent District': 'ស្រុក​បច្ចុប្បន្ន',
  'Permanent Province': '​ខេត្តបច្ចុប្បន្ន',
  'Post Code': 'លេខកូដតំបន់',
  Province: 'ខេត្ត',
  'Probation Date': 'ថ្ងៃបញ្ចប់សាកល្បងការងារ',
  'Personal Information': 'ព័ត៌មានផ្ទាល់ខ្លួន',
  Profile: 'ប្រវត្តិរូប',
  'Position Code': 'លេខកូដតួនាទី',
  'Posting Date': 'ថ្ងៃប្រកាស',
  'Pay In Step': 'ទូទាត់ជាដំណាក់កាល',
  'Pay In Month': 'ទូទាត់ជាខែ',
  'Pay In Year': 'ទូទាត់ជាឆ្នាំ',
  'Payroll Detail': 'ព័ត៌មានលម្អិតអំពីប្រាក់ខែ',
  'Pension Fund 2% Pay': 'បង់ប្រាក់សោធននិវត្តន៍ 2%',
  'Payroll Calculation Details': 'ព័ត៌មានលម្អិតអំពីការគណនាប្រាក់បៀវត្សរ៍',
  'Pending Approval': 'រងចាំការអនុម័ត',
  Pending: 'រងចាំ',
  Print: 'បោះពុម្ព',
  'Pending Check': 'រង់ចាំការត្រួតពិនិត្យ',
  'Public Holiday': 'ថ្ងៃឈប់​សំរាក​បុណ្យជាតិ',
  'Partially meet less than': 'ជួបដោយផ្នែកតិចជាង',
  'Partially meet around': 'ជួបដោយផ្នែកជុំវិញ',
  'Partially meet more than': 'ផ្នែកខ្លះជួបច្រើនជាង',
  'Partially Meets': 'តាមការរំពឹងទុកដោយផ្នែក',
  'Penalty Leave': 'ច្បាប់ឈប់ដោយមានការពិន័យ',
  'Paternity Leave': 'ច្បាប់បិតុភាព',
  'Personal Info. Change Request': 'ពាក្យស្នើសុំផ្លាស់ប្ដូរព័ត៌មានផ្ទាល់ខ្លួន',
  'Probation Status': 'លទ្ធផលនៃការសាកល្បង',
  'Personal Information Of The Complainant': 'ព័ត៌មានផ្ទាល់ខ្លួនរបស់អ្នកប្តឹង',
  'Please help of evaluated the effectiveness of this training. The training is divided into 4 parts.':
    'សូមចូលរួមវាយតម្លៃការបណ្តុះបណ្តាលនេះដើម្បីឱ្យការបណ្តុះបណ្តាលកាន់តែមានប្រសិទ្ធិភាព​ ការវាយតម្លៃនេះបានចែកជាផ្នែក៤សំខាន់៖',
  'Please Rating The Quality Of The Training From 1-4': 'សូមលោកគ្រូអ្នកគ្រូឱ្យចំណាត់ថ្នាក់តាមការយល់ឃើញ៖',
  'Personal Management': 'ផ្នែកព័ត៌មានបុគ្គលិក',
  Processing: 'កំពុងដំណើរការ',
  'Pending Task/Projects (Any Pending Tasks or under Progress during the Handover':
    'កិច្ចការដែលមិនទាន់សម្រេច (រាល់កិច្ចការដែលមិនទាន់សម្រេច ឬកំពុងដំណើរការក្នុងអំឡុងពេលប្រគល់)',
  Position: 'មុខដំណែង',
  Personal: 'ព័ត៌មានបុគ្គលិក',
  'Progress (%)': 'ការរីកចម្រើន (%)',
  'PVF Pay': 'បង់ជា PVF',
  'Pay In Month & Year': 'បង់ជាខែនិងឆ្នាំ',
  'Payslip Password': 'ពាក្យសម្ងាត់ប័ណ្ណប្រាក់បៀវត្សរ៍',
  'Prolong illness Leave': 'ច្បាប់ឈឺរយៈពេលយូរ',
  Period: 'រយៈពេល',
  'Please provide your suggestion(s) to enable the Company to improve both working condition and business':
    'សូមផ្តល់យោបល់របស់អ្នកដើម្បីធ្វើឲ្យក្រុមហ៊ុនកាន់តែមានភាពប្រសើរឡើងទាំងលក្ខខណ្ឌការងារ និងក្រុមហ៊ុន',
  'Personal Information Of Survey': 'ព័ត៌មានផ្ទាល់ខ្លួននៃការស្ទង់មតិ',
  'Pending Review': 'រង់ចាំការពិនិត្យឡើងវិញ',
  'Pending Verify': 'រង់ចាំការផ្ទៀងផ្ទាត់',

  // Q
  Questionnaire: 'សំណួរ',

  // R

  'Request For': 'ស្នើសុំឲ្យ',
  Resubmit: 'Resubmit',
  Resignation: 'Resignation',
  Reference: 'យោង',
  'Reason of Termination': 'មូលហេតុនៃការបញ្ចប់',
  'Reference for Khmer': 'Reference for Khmer',
  Remarried: 'រៀបការម្តងទៀត',
  'Document Receive Date': 'ថ្ងៃទទួលឯកសារ',
  'Register Now': 'ចុះឈ្មោះឥឡូវនេះ',
  'Registration Date': 'ថ្ងៃចុះឈ្មោះ',
  Relationship: 'ទំនាក់ទំនង',
  'Residential Status': 'ស្ថានភាពលំនៅដ្ឋាន',
  Request: 'ស្នើសុំ',
  Return: 'ត្រឡប់មកវិញ',
  Room: 'បន្ទប់',
  'Reset all': 'កំណត់ឡើងវិញទាំងអស់',
  'Review By': 'ពិនិត្យឡើងវិញដោយ',
  'Swap Card': 'ប្តូរកាត',
  'Resignation Notice Date': 'ថ្ងៃជូនដំណឹងលាឈប់',
  'Resignation/Terminated Date': 'ថ្ងៃលាឈប់/ផ្អាក់ការងារ',
  Resident: 'អ្នករស់នៅ',
  Remark: 'កត់ចំណាំ',
  Returned: 'ត្រឡប់',
  'Reason Of Leave Request': 'មូលហេតុនៃការសុំច្បាប់',
  'Resignation Request Form': 'ពាក្យស្នើសុំលាឈប់ពីការងារ',
  'Resignation Request': 'ពាក្យស្នើសុំលាឈប់ពីការងារ',
  Recruitment: 'ផ្នែកជ្រើសរើសបុគ្គលិក',
  'Request Change to Update Timesheets': 'ស្នើសុំដើម្បីផ្លាស់ប្តូរតារាងពេលវេលា',
  'Request Change': 'ស្នើសុំផ្លាស់ប្តូរ',
  Requester: 'អ្នកស្នើសុំ',
  'Requested By': 'អ្នកស្នើសុំ',
  'Request Change Personal Information': 'ពាក្យស្នើសុំផ្លាស់ប្ដូរព័ត៌មានផ្ទាល់ខ្លួន',
  'Request Change Contact & Emergency Contact': 'ពាក្យស្នើសុំផ្លាស់ប្ដូរលេខទំនាក់ទំនង និងលេខ​ទំនាក់ទំនង​បន្ទាន់',
  'Request Change Birth Address Information': 'ពាក្យស្នើសុំផ្លាស់ប្ដូរព័ត៌មាននៃទីកន្លែងកំណើត',
  'Request Change Permanent Address Information': 'ពាក្យស្នើសុំផ្លាស់ប្ដូរព័ត៌មានអាស័យដ្ឋានបច្ចុប្បន្ន',
  'Request Change Current Address Information': 'ពាក្យស្នើសុំផ្លាស់ប្ដូរព័ត៌មានអាស័យដ្ឋានអចិន្ត្រៃយ៍',
  'Reason Of Overtime Request': 'មូលហេតុនៃសំណើបន្ថែមម៉ោង',
  'Religion Code': 'កូដសាសនា',
  'Review Date': 'ថ្ងៃពិនិត្យឡើងវិញ',
  'Reason Of Change DayOff': 'មូលហេតុនៃការផ្លាស់ប្ដូរថ្ងៃឈប់សម្រាក',
  Rejected: 'បដិសេធ',
  Reject: 'បដិសេធ',
  Regular: 'ថែមម៉ោងធម្មតា',
  Released: 'បានអនុម័ត',
  Records: 'កំណត់ត្រា',
  Record: 'កំណត់ត្រា',
  'Request For Name': 'ស្នើសុំសម្រាប់ឈ្មោះ',
  'Request For Gender': 'ពាក្យសុំសម្រាប់ភេទ',
  'Request For Relationship': 'សំណើសម្រាប់ទំនាក់ទំនង',
  'Request For No Of Scholarship': 'ស្នើសុំចំនួនអាហារូបករណ៍',
  'Reason of Change Request': 'មូលហេតុនៃការផ្លាស់ប្តូរ',
  'Resignation Form Request': 'ពាក្យសុំលាឈប់',
  'Reason Of Resignation': 'មូលហេតុនៃការលាឈប់',
  'Request Details': 'ស្នើសុំលម្អិត',
  'Reason Of Request': 'មូលហេតុនៃការស្នើសុំ',
  'Request Date': 'ថ្ងៃស្នើសុំ',
  Resilience: 'Resilience',
  'Request Of Complaint Details': 'សំណើព័ត៌មានលម្អិតនៃពាក្យបណ្តឹង',
  'Reasons for leaving': 'មូលហេតុនៃការសុំលាឈប់',
  Reviewed: 'បានពិនិត្យឡើងវិញ',
  'Resignation Detail': 'ព័ត៌មានលម្អិតអំពីការលាលែងពីការងារ',
  'Resignation Date': 'ថ្ងៃលាលែងពីការងារ',
  'Remaning of day': 'ថ្ងៃនៅសល់',
  'Require Register': 'តម្រូវឱ្យចុះឈ្មោះ',
  'Reason of Overtime Request': 'មូលហេតុនៃការស្នើសុំបន្ថែមម៉ោង',
  'Registration Status': 'ស្ថានភាពចុះឈ្មោះ',

  // S

  'Scholarship Child Order': 'លំដាប់កូនដែលទទួលអាហារូបករណ៍',
  'Spouse or Child’s Gender': 'ភេទសហព័ទ្ធ ឬកូន',
  'Spouse or Child’s Name': 'ឈ្មោះសហព័ទ្ធ ឬកូន',
  'Subject Option': 'មុខវិជ្ជា',
  'Shift Group': 'Shift Group',
  'Standby Location': 'ទីតាំងរង់ចាំ',
  'Standby Building Code': 'លេខកូដអគាររង់ចាំ',
  'Staff Leaving': 'បុគ្គលិកចាកចេញ',
  'See more': 'មើលបន្ថែម',
  'Salary Adjustment': 'កែសម្រួលប្រាក់ខែ',
  Sessions: 'វគ្គ',
  Spouse: 'សហព័ទ្ធ',
  Separated: 'បំបែក',
  Single: 'នៅលីវ',
  'Scoring of Survey and Tardiness or Attendance Score': 'ពិន្ទុស្ទាបស្ទង់មតិ និងភាពយឺតយ៉ាវ ឬពិន្ទុវត្តមាន',
  'Scoring of Survey and Attendance': 'ពិន្ទុស្ទាបស្ទង់មតិនិងពិន្ទុវត្តមាន',
  'Survey Result (Score)': 'លទ្ធផលពិន្ទុស្ទង់មតិ',
  'Sick Leave Entitlement Balance': 'កំណត់ត្រាសិទ្ធិឈប់សម្រាកឈឺ',
  'Suspended Start Date': 'ថ្ងៃចាប់ផ្តើមព្យួរការងារ',
  'Suspended Start Date/Terminate Effective Date': 'Suspended Start Date/Terminate Effective Date',
  'Suspend Leave': 'សុំព្យួរការងារ',
  'Suspend Duration (If any)': 'រយះពេលព្យួរការងារ (បើមាន)',
  'Sub Unit': 'ក្នុងផ្នែក',
  'Shift Code': 'ប្តូរកូដ',
  'Swipe Card Machine Code': 'កូដម៉ាស៊ីនឆូតកាត',
  'Send Notify To Successor': 'ផ្ញើការជូនដំណឹងទៅអ្នកបន្ត',
  'Send Notify To Delegator': 'ផ្ញើការជូនដំណឹងទៅអ្នកបន្ត',
  'Send Notify To Line Manager': 'ផ្ញើការជូនដំណឹងទៅអ្នកបន្ត',
  Subject: 'ប្រធានបទ',
  'Successor Status': 'ស្ថានភាពអ្នកបន្តការងារ',
  'School Fee In Total': 'តម្លៃសិក្សាសរុប',
  'School Fee In Semester': 'តម្លៃសិក្សាក្នុងមួយឆមាស',
  'School Fee In Year': 'តម្លៃសិក្សាក្នុងមួយឆ្នាំ',
  'Suspend Duration': 'រយៈពេលព្រួរកាងារ',
  'Scholarship Granted': 'អាហារូបករណ៍ដែលទទួលបាន',
  'Second Priority Skills': 'ជំនាញអាទិភាពទី២',
  'Second Priority Remark': 'ការកំណត់សម្គាល់អាទិភាពទី២',
  'Subspend Leave Request Form': 'ពាក្យស្នើសុំឈប់សម្រាកបណ្តោះអាសន្ន',
  'Suspended Leave Request': 'ពាក្យស្នើសុំឈប់សម្រាកបណ្តោះអាសន្ន',
  'Suspension Leave Details': 'ព័ត៌មានលម្អិតអំពីការចាកចេញ',
  'Suspension Leave Option': 'ជម្រើសចាកចេញពីការផ្អាក',
  'Sub Employee No': 'លេខបុគ្គលិករង',
  'Sub Name': 'ឈ្មោះរង',
  'Sub Service Lenght': 'ប្រវែងសេវាកម្មរង',
  'Sub Gender': 'ភេទរង',
  'Substitution Request Form': 'ពាក្យស្នើសុំជំនួស',
  'Sub Career Code': 'លេខកូដអាជីពរង',
  'Snack Break Code': 'កូដអាហារសម្រន់',
  Signature: 'ហត្ថលេខា',
  'Start Date': 'ថ្ងៃចាប់ផ្តើម',
  'Start Date ': 'ថ្ងៃចូលធ្វើការ',
  'Service Length': 'រយះពេលបម្រើការងារ',
  'Staff Information Record': 'តារាងរាយនាមបុគ្គលិក',
  'Scholarship Request Form': 'ពាក្យស្នើសុំអាហារូបករណ៍',
  'Salary Certificate Request Form': 'ពាក្យស្នើសុំលិខិតបញ្ជាក់ប្រាក់ខែ',
  'Starting Time': 'ម៉ោងចាប់ផ្តើម',
  'Starting Date': 'ថ្ងៃចូលធ្វើការ',
  'Starting Date 1': 'ថ្ងៃចាប់ផ្តើម',
  Soft: 'ទន់',
  'Soft Skills Assessment': 'ការវាយតម្លៃជំនាញទន់',
  Search: 'ស្វែងរក',
  Submit: 'ដាក់ស្នើ',
  Saturday: 'ថ្ងៃសៅរ៍',
  Sunday: 'ថ្ងៃអាទិត្យ',
  'Send Approval': 'ផ្ញើដើម្បីស្នើអនុញ្ញាត',
  Send: 'ផ្ញើ',
  'Survey Assessment': 'ការវាយតម្លៃការស្ទង់មតិ',
  'Self Rating Option': 'ការដាក់ពិន្ទុដោយបុគ្គលិក',
  'Skill Description': 'ការពិពណ៌នាជំនាញ',
  'Soft Skill Description': 'ការពិពណ៌នាអំពីជំនាញទន់',
  'Self Score': 'ពិន្ទុខ្លួនឯង',
  'Survey Score': 'ពិន្ទុស្ទាបស្ទង់មតិ',
  Satisfactory: 'ពេញចិត្ត',
  'Sick Leave': 'ច្បាប់ឈឺ',
  'Special Leave': 'ច្បាប់ឈប់សម្រាកពិសេស',
  'Subspend Leave': 'ផ្អាកការចាកចេញ',
  'Successful Probation': 'ការសាកល្បងជោគជ័យ',
  'Salary Certificate Request': 'ពាក្យស្នើសុំវិញ្ញាបនបត្រប្រាក់ខែ',
  'Suspended Working': 'ព្យួរការងារចំនួនថ្ងៃ',
  'Strongly Disagree': 'មិនយល់ស្របខ្លាំង',
  'Strongly Agree': 'យល់ស្របខ្លាំង',
  'Skill Category Code': 'កូដប្រភេទជំនាញ',
  'Stategic Thinking': 'យុទ្ធសាស្ត្រនៃការគិត',
  Status: 'ស្ថានភាព',
  'Successor No': 'លេខអ្នកបន្តការងារ',
  'Successor ID': 'អ្នកទទួលការងារបន្ត',
  'Software Data (Electronic Files), Password of Systems/Files': 'ទិន្នន័យទន់ (ឯកសារអេឡិចត្រូនិក), ពាក្យសម្ងាត់នៃប្រព័ន្ធឯកសារ',
  'Staff End Probation in 30 Days': 'បុគ្គលិកបញ្ចប់ការសាកល្បងការងារក្នុងរយៈពេល ៣០ ថ្ងៃ',
  Summary: 'សង្ខេប',
  'Satisfied, Ordinary, Disatified': 'ពេញចិត្ត, ធម្មតា, មិនពេញចិត្ត',
  'Survey Score Result': 'លទ្ធផលពិន្ទុស្ទង់មតិ',
  'Suspended Working Day': 'ផ្អាកថ្ងៃធ្វើការ',
  'Subspended Ending Date': 'បញ្ចប់ផ្អាកថ្ងៃធ្វើការ',
  'Suspended/Terminate Effective Date': 'ផ្អាក/បញ្ចប់ថ្ងៃមានប្រសិទ្ធភាព',
  'Submission Date': 'ថ្ងៃដាក់ស្នើ',
  'Submit Date': 'ថ្ងៃដាក់ស្នើ',
  'Short Notice Period': 'ការជូនដំណឹងមិនគ្រប់',
  'Service Lenght': 'រយៈពេលសេវាកម្ម',
  'Service Lenght 1': 'រយៈពេលបម្រើការងារ',
  'Step Type': 'ប្រភេទជំហាន',
  Step: 'ជំហាន',
  'Step Option': 'ជម្រើសជំហាន',
  'Select Workflow Committee': 'ជ្រើសរើសគណៈកម្មការនៃការអនុម័ត',
  'Send To': 'បញ្ជូនទៅ',
  'Suspended Work for investigation': 'ផ្អាកការងារសម្រាប់ការស៊ើបអង្កេត',
  Satisfied: 'ពេញចិត្ត',

  // T
  'Training Status': 'ស្ថានភាពបណ្តុះបណ្តាល',
  'To Expired Date': 'កាលបរិច្ឆេទហួសកំណត់អត្តសញ្ញាណប័ណ្ណថ្មី',
  'To Issued Date': 'កាលបរិច្ឆេទចេញកំណត់អត្តសញ្ញាណប័ណ្ណថ្មី',
  'To ID Card Number': 'លេខអត្តសញ្ញាណប័ណ្ណថ្មី',
  'To Phone Number': 'លេខទូរស័ព្ទថ្មី',
  'To Bank Account Number': 'លេខគណនីធនាគារថ្មី',
  'To Bank Account Name': 'ឈ្មោះគណនីធនាគារថ្មី',
  'To Account Number': 'លេខគណនីថ្មី',
  'To National ID Card': 'លេខអត្តសញ្ញាណប័ណ្ណថ្មី',
  'To National ID Card Issue Date': 'កាលបរិច្ឆេទចេញកំណត់អត្តសញ្ញាណប័ណ្ណថ្មី',
  'To Issue Date': 'កាលបរិច្ឆេទចេញកំណត់អត្តសញ្ញាណប័ណ្ណថ្មី',
  'To Bank Name': 'ឈ្មោះធនាគារថ្មី',
  'To National ID Card Expired Date': 'កាលបរិច្ឆេទហួសកំណត់អត្តសញ្ញាណប័ណ្ណថ្មី',
  'To Company Phone Number': 'លេខទូរស័ព្ទក្រុមហ៊ុនថ្មី',
  Termination: 'Termination',
  'Termination Details': 'ព័ត៌មានលម្អិតអំពីការបញ្ចប់កិច្ចសន្យា',
  'Tardiness or Attendance Score': 'ពិន្ទុវត្តមាន ឬភាពយឺតយ៉ាវ',
  'Training and Development': 'ការបណ្តុះបណ្តាល និងការអភិវឌ្ឍន៍',
  'Training Information': 'ព័ត៌មានបណ្តុះបណ្តាល',
  'Team Code': 'កូដក្រុម',
  'Training By': 'បណ្តុះបណ្តាលដោយ',
  'Training Calendar Registration': 'Training Calendar Registration',
  'To Relationship': 'ទំនាក់ទំនងថ្មី',
  'To Contact Number 2': 'លេខទំនាក់ទំនង ២ថ្មី',
  'To Contact Number': 'ទៅលេខទំនាក់ទំនងថ្មី',
  'To First Name in Khmer': 'នាមខ្លួន ជាអក្សរខ្មែរថ្មី',
  'To Last Name in Khmer': 'នាមត្រកូល ជាអក្សរខ្មែរថ្មី',
  'To First Name in Latin': 'នាមខ្លួន ជាអក្សរឡាតាំងថ្មី',
  'To Last Name in Latin': 'នាមត្រកូល ជាអក្សរឡាតាំងថ្មី',
  'To Permanent Address in Khmer': 'អាស័យដ្ឋាន​បច្ចុប្បន្នថ្មី ជាអក្សរខ្មែរ',
  'Terminate Effective Date': 'Terminate Effective Date',
  'Type Of The Scholarship': 'ប្រភេទអាហារូបករណ៍',
  Topic: 'ប្រធានបទ',
  'Training Needs Assessment': 'ទម្រង់ប្រមូលព័ត៍មានពីតម្រូវការ និងការអភិវឌ្ឍ',
  'Third Priority Skills': 'ជំនាញអទិភាពទី៣',
  'Third Priority Remark': 'ការកត់សម្គាល់អទិភាពទី៣',
  'Training Location': 'ទីតាំងបណ្តុះបណ្តាល',
  'Training Sponsor Remark': 'កំណត់សម្គាល់របស់អ្នកឧបត្ថម្ភការបណ្តុះបណ្តាល',
  'Training Sponsor': 'អ្នកឧបត្ថម្ភការបណ្តុះបណ្តាល',
  Term: 'រយៈពេល',
  'Term 1': 'ត្រីមាស',
  'Telegram ID': 'អត្តសញ្ញាណតេឡេក្រាម',
  To: 'ដល់ថ្ងៃ',
  'To Worksheet Code': 'ទៅកាន់លេខកូដក្រុមវេនធ្វើការ',
  'To Working Date (OFF)': 'ប្ដូរទៅកាន់ថ្ងៃ',
  'Tardiness Request Form': 'ពាក្យស្នើសុំអាក់ខានឆូតកាតចេញចូល',
  Training: 'ការបណ្ដុះបណ្ដាល',
  'Training Questionnaires': 'កម្រងសំណួរបណ្ដុះបណ្ដាល',
  'To Name': 'ឈ្មោះថ្មី',
  'To Gender': 'ទៅកាន់ភេទ',
  'To Marital Status': 'ស្ថានភាពអាពាហ៍ពិពាហ៍ថ្មី',
  'To Date Of Birth': 'ថ្ងៃខែឆ្នាំកំណើតថ្មី',
  'To ID Card No': 'លេខសម្គាល់ខ្លួនបុគ្គលិកថ្មី',
  'To Passport No': 'លេខលេខលិខិតឆ្លងដែនថ្មី',
  'To Emergency Contact Phone No': 'ទៅកាន់លេខទំនាក់ទំនងបន្ទាន់',
  'To Emergency Contact Name': 'ទៅកាន់ឈ្មោះទំនាក់ទំនងបន្ទាន់',
  'To Phone No': 'ទៅកាន់លេខទូរស័ព្ទ',
  'To Email': 'ទៅកាន់អ៊ីម៉ែល',
  'To Birth Address': 'ទៅកាន់ទីកន្លែងកំណើត',
  'To Birth District': 'ទៅកាន់ស្រុកកំណើត',
  'To Birth Province': 'ទៅកាន់ខេត្តកំណើត',
  'To Birth Country Code': 'ទៅកាន់លេខកូដប្រទេស',
  'To Permanent Address': 'អាស័យដ្ឋានបច្ចុប្បន្នថ្មី',
  'To Permanent District': 'ទៅកាន់ស្រុកបច្ចុប្បន្ន',
  'To Permanent Province': 'ទៅកាន់ខេត្តបច្ចុប្បន្ន',
  'To Post Code': 'ទៅកាន់កូដតំបន់',
  'To Address': 'អាស័យដ្ឋានថ្មី',
  'To District': 'ទៅកាន់ស្រុក',
  'To Province': 'ទៅកាន់ខេត្ត',
  Time: 'ម៉ោង',
  'Tax Pay': 'បង់ពន្ធ',
  'Training Leave': 'ច្បាប់សម្រាកបណ្ដុះបណ្ដាល',
  Type: 'ប្រភេទ',
  'Training Fees': 'ថ្លៃវគ្គបណ្តុះបណ្តាល',
  'Title of the Incident': 'ប្រភេទឧប្បត្តិហេតុ',
  Terminated: 'បញ្ឈប់ពីការងារ',
  Teamwork: 'ការងារក្រុម',
  'Training Topic Test Assessment Test': 'ធ្វើតេស្តលើកម្រងសំណួរវគ្គបណ្តុះបណ្តាលស្តីពីជំនាញ',
  'Training History': 'ប្រវត្តិការបណ្ដុះបណ្ដាល',
  'Training Topic Assessment Test': 'តេស្តវាយតម្លៃប្រធានបទបណ្ដុះបណ្ដាល',
  'Training History Record': 'ប្រវត្តិការចូលរួមវគ្គបណ្តុះបណ្តាល',
  'Task Description': 'ពណ៌នាកិច្ចការ',
  'Task Group': 'កិច្ចការក្រុម',
  'To Successor': 'ទៅអ្នកទទួលការងារបន្ត',
  'To Main Successor': 'ទៅអ្នកទទួលការងារបន្ត',
  'Training & Development': 'ការបណ្តុះបណ្តាល',
  Title: 'ចំណងជើង',
  'To Time': 'ដល់ម៉ោង',
  'THIS MONTH': 'ខែនេះ',
  'Total Completed': 'ចំនួនរួចរាល់',
  'Total Processing': 'ចំនួន ដំណើរការ',
  'Total Pending': 'ចំនួន រង់ចាំ',
  'Termination Request Form': 'ការស្នើសុំបញ្ចប់',
  'Termination Request': 'ការស្នើសុំបញ្ចប់',
  Total: 'ចំនួន',
  'Terminiation Type': 'ប្រភេទការបញ្ចប់',
  'Training Calendar': 'ប្រតិទិនបណ្ដុះបណ្ដាល',
  'Training Channel': 'មធ្យោបាយបណ្ដុះបណ្ដាល',
  'Training venue': 'ទីតាំងបណ្ដុះបណ្ដាល',
  'Training Duration Remark': 'កំណត់សម្គាល់ចំនួនថ្ងៃបណ្ដុះបណ្ដាល',
  'Training Employee Name': 'ឈ្មោះនិយោជិតបណ្ដុះបណ្ដាល',
  'Traget Audience': 'គោលដៅអ្នកស្តាប់',
  'Training Employee No': 'លេខនិយោជិតបណ្ដុះបណ្ដាល',
  'Training Topic': 'ប្រធានបទបណ្ដុះបណ្ដាល',
  'Training Program Remark': 'សម្គាល់កម្មវិធីបណ្ដុះបណ្ដាល',
  'Training Program Code': 'កូដកម្មវិធីបណ្ដុះបណ្ដាល',
  'Training Fee Remark': 'ការកត់សម្គាល់តម្លៃបណ្តុះបណ្តាល',
  'Training Option': 'ជម្រើសបណ្តុះបណ្តាល',
  'Training Type': 'ប្រភេទនៃបណ្តុះបណ្តាល',
  'The main objective of the course': 'គោលបំណងសំខាន់នៃវគ្គបណ្តុះបណ្តាល',
  "Trainer's ID": 'លេខអត្តសញ្ញាណអ្នកបណ្តុះបណ្តាល',
  "Trainer's Name": 'ឈ្មោះអ្នកបណ្តុះបណ្តាល',
  Tuesday: 'ថ្ងៃអង្គារ',
  Thursday: 'ថ្ងៃព្រហស្បតិ៍',
  'Tax Base Amount': 'ចំនួនទឹកប្រាក់ពន្ធគោល',
  'Tax Pay Amount': 'ចំនួនទឹកប្រាក់បង់ពន្ធ',
  'Tax Base Amount (1st & 2nd)': 'ចំនួនទឹកប្រាក់មូលដ្ឋានពន្ធ (ទី 1 និងទី 2)',
  'Training Date': 'ថ្ងៃបណ្តុះបណ្តាល',
  'Training Time': 'ពេលវេលាបណ្តុះបណ្តាល',
  'Training Source': 'ប្រភពបណ្តុះបណ្តាល',
  'The knowledge that you have already improved before join the course': 'ចំណេះដឹងរបស់អ្នក មុនពេលចូលរួមវគ្គបណ្តុះបណ្តាល',
  'The knowledge that you have learned and improved after the course': 'ចំណេះដឹងដែលអ្នកទទួលបាន ក្រោយចូលរូមវគ្គបណ្តុះបណ្តាល',
  'The knowledge that you will be able to use or implement in the company': 'ចំណេះដឹងដែលអ្នកនឹងយកមកអនុវត្តនៅក្នុងក្រុមហ៊ុន',
  'Total Hours': 'ចំនួនម៉ោងសរុប',

  // U

  Unavailable: 'មិនមាន',
  Unchecked: 'មិនទាន់បានពិនិត្យ',
  Unit: 'ផ្នែក',
  'University / Institute Name': 'ឈ្មោះសាកលវិទ្យាល័យ / វិទ្យាស្ថាន',
  undefined: 'មិនបានកំណត់',
  Unacceptable: 'មិនអាចទទួលយកបាន',
  Unsatisfactory: 'មិនពេញចិត្ត',
  'Unpaid Leave': 'ច្បាប់សម្រាកដែលមិនទទួលបានប្រាក់ឈ្នួល',
  'Upload Files': 'បញ្ជូលឯកសារ',
  'Unsuccessful Probation': 'ការសាកល្បងមិនជោគជ័យ',
  'Update Activity Status': 'កែតម្រូវស្ថានភាពសកម្មភាព',
  'Usage of day': 'ការប្រើប្រាស់ថ្ងៃ',
  Username: 'ឈ្មោះអ្នកប្រើប្រាស់',
  'User ID': 'លេខសំគាល់អ្នកប្រើប្រាស់',

  // V
  'Verbal Warning': 'ការព្រមានផ្ទាល់មាត់',
  'Visa Expiry Remark': 'សម្គាល់អំពីកាលផុតកំណត់Visa',
  Verified: 'បានបញ្ជាក់',
  'Verify By': 'ផ្ទៀងផ្ទាត់ដោយ',

  // W

  'Working Hour Changed': 'ផ្លាស់ប្តូរម៉ោងធ្វើការ',
  Widowed: 'មេម៉ាយ',
  'Weightage % (Survey)': 'ទម្ងន់ពិន្ទុនៃការស្ទង់មតិ',
  'What challenges in term of skills and capacity are you facing in carrying out your work and responsibilities?':
    'តើអ្នកកំពុង​ប្រឈមនឹងឧបសគ្គផ្នែក​សមត្ថភាព​ និងជំនាញអ្វីខ្លះក្នុងការ​អនុវត្ត​ការងារ និង​ភារកិច្ច​របស់​អ្នក?',
  'What training courses needed to improve your capacity and support your role and responsibilities more effectively? Please list down 3 priority training courses?':
    'តើអ្នកមានត្រូវការវគ្គបណ្តុះបណ្តាលអ្វីខ្លះដើម្បីជួយពង្រឹងសមត្ថភាព និងការងាររបស់អ្នកឲ្យកាន់តែមានប្រសិទ្ធភាព? សូមបញ្ជាក់វគ្គបណ្តុះបណ្តាលចំនួន៣',
  'Working Date': 'ថ្ងៃធ្វើការ',
  'Working Date (OFF)': 'ថ្ងៃឈប់សម្រាក',
  'Working Condition Type': 'ប្រភេទលក្ខខណ្ឌការងារ',
  'Worksheet Code': 'លេខកូដក្រុមវេនធ្វើការ',
  'Weekend Day': 'ថ្ងៃចុងសប្តាហ៍',
  Weekend: 'ចុងសប្តាហ៍',
  Weekday: 'ថ្ងៃធ្វើការ',
  'Weightage % (Other)': 'ទម្ងន់ពិន្ទុវាយតម្លៃលើជំនាញ-អាកប្បកិរិយា',
  'Weightage % (KPI)': 'ទម្ងន់ពិន្ទុដែលកំណត់លើ KPI',
  Weight: 'ទម្ងន់ពិន្ទុ',
  'Weight (%)': 'ទម្ងន់ពិន្ទុ',
  'Written Warning': 'ការព្រមានដោយលាយលក្ខណ៍អក្សរ',
  'Work Book Expiry Remark': 'សម្គាល់អំពីកាលផុតកំណត់សៀវភៅការងារ',
  'Work Permit Book Expiry Remark': 'សម្គាល់អំពីកាលផុតកំណត់សៀវភៅអនុញ្ញាតការងារ',
  Working: 'ការងារ',
  'What would have made you keep staying with the Company?': 'តើមានអ្វីដែលធ្វើឱ្យអ្នកផ្លាស់ប្តូរក្នុងការបន្តបម្រើការងារនៅក្នុងក្រុមហ៊ុននេះទេ?',
  'What changes would you suggest?': 'តើអ្នកចង់ស្នើសុំឲ្យមានការផ្លាស់ប្តូរអ្វីខ្លះ?',
  'Workflow Committee': 'គណៈកម្មការនៃការអនុម័ត',
  'Workflow Committees': 'គណៈកម្មការនៃការអនុម័ត',
  'Weightage (Attendance)': 'ទម្ងន់ពិន្ទុនៃវត្តមាន',
  'Working Day': 'ថ្ងៃធ្វើការ',
  Wednesday: 'ថ្ងៃពុធ',
  'Written Warning with Suspended Working': 'ការព្រមានសរសេរជាមួយការបញ្ឈប់ការងារ',
  'We Value Your Feedback': 'We Value Your Feedback',
  Waive: 'Waive',
  'Waiver after AL deduction': 'Waiver after AL deduction',

  // X

  // Y
  'Your Comments on Salary & Benefits with the Company': 'មតិយោបល់របស់អ្នកលើប្រាក់បៀវត្ស និងអត្ថប្រយោជន៍',
  'Your Comments on Working Conditions & Culture': 'មតិយោបល់របស់អ្នកលើលក្ខខណ្ឌបរិយាកាសការងារ និងវប្បធម៌ក្នុងក្រុមហ៊ុន',
  'Your Comments about Your Line Manager/Head of Department': 'មតិយោបល់របស់អ្នកលើប្រធានគ្រប់គ្រងផ្ទាល់ និងប្រធាននាយកដ្ឋានរបស់អ្នក',
  'Your Other and Feedbacks': 'ផ្សេងទៀត និងមតិរបស់អ្នក។',
  'Your Personal Contact information After Leaving': 'ព័ត៍មានផ្ទាល់ខ្លួនរបស់បុគ្គលិកបន្ទាប់ពីការចាកចេញ',
  'Your Expected Results after the training': 'លទ្ធផលរំពឹងទុករបស់អ្នកក្រោយការបណ្តុះបណ្តាល',
  'Yes, delete!': 'បាទ/ចាស!លុប',
  Yes: 'បាទ/ចាស',
  Year: 'ឆ្នាំ',

  // Z

  // Number

  0: '០',
  1: '១',
  2: '២',
  3: '៣',
  4: '៤',
  5: '៥',
  6: '៦',
  7: '៧',
  8: '៨',
  9: '៩',
};
export default enMessages;
